require.register("app/restaurant/copy/RangeAndDeliveryDayForm", function(exports, require, module){
  $0
  
});

